import { clearSelectedRecipient } from "./selectedRecipientPersist";
import { clearCountryCurrency } from "./countryCurrencyPersist";
import { clearSendMoneyLimits } from "./limitsPersist";

/**
 * Clears every Send Money value persisted to sessionStorage. Add new persist
 * modules here so reset/logout picks them up automatically.
 */
export const clearSendMoneyPersistence = (): void => {
  clearSelectedRecipient();
  clearCountryCurrency();
  clearSendMoneyLimits();
};